import * as CONSTANTS from '../_constants';
import { Exception } from 'handlebars';

export const BASE_API_URL = 'https://aicpg.org/mygc?r=https://my.guidelinecentral.com/api/?token=91c9099f51854d28567bb160cae95b4f97ce3013';

export const generateSlugFromTitle = (title) => {
    return title.split("/").join(" ").split(" ").map((x)=>x.toLowerCase()).join("-");
}

export const generateAPIUrlTypeSectionAndTitle = (type, section, title) => {
    
    let finalUrlString = "";
    
    if(!type) throw(new Exception("Cannot generate url from empty type"));
    
    finalUrlString += `&action=${type}`

    if(section && title) {
        finalUrlString += `&${section}=${encodeURIComponent(title)}`;
    }

    return `${BASE_API_URL}${finalUrlString}`;
}

export const generateSummaryLinkFromTypeSectionAndTitle = (type, section, slug) => {
    return `${type}/${section}/${slug}`
}

export const getAPIActionFromSection = (section) => {
    
    switch(section) {
        case CONSTANTS.SECTIONS.CATEGORY :
            return CONSTANTS.ENDPOINTS.GET_SUMMARIES_FOR_CATEGORY;
        case CONSTANTS.SECTIONS.ORGANIZATION :
            return CONSTANTS.ENDPOINTS.GET_SUMMARIES_FOR_ORGANIZATION;
        case CONSTANTS.SECTIONS.PROFESSION :
            return CONSTANTS.ENDPOINTS.GET_SUMMARIES_FOR_PROFESSION;
        case CONSTANTS.SECTIONS.SPECIALTY :
            return CONSTANTS.ENDPOINTS.GET_SUMMARIES_FOR_SPECIALTY;
        case CONSTANTS.SECTIONS.SEARCH :
            return CONSTANTS.ENDPOINTS.SEARCH_SUMMARIES;
        default :
            throw(new Exception(`Cannot determine action from provided section: ${section}`));
    }
}

export const getSectionSingularForm = (section) => {
    switch(section) {
        case CONSTANTS.SECTIONS.CATEGORIES :
            return CONSTANTS.SECTIONS.CATEGORY;
        case CONSTANTS.SECTIONS.ORGANIZATIONS :
            return CONSTANTS.SECTIONS.ORGANIZATION;
        case CONSTANTS.SECTIONS.PROFESSIONS :
            return CONSTANTS.SECTIONS.PROFESSION;
        case CONSTANTS.SECTIONS.SPECIALTIES :
            return CONSTANTS.SECTIONS.SPECIALTY;
        default :
            throw(new Exception(`Cannot determine singular form from provided section: ${section}`));
    }
}